<template>
  <iframe id="assessmentIframe" :src="$config.get('basePathFiles') + 'static/libs/assessments/index.html'" v-on:load="loadAssessmentDetails()">
  </iframe>
</template>

<script>
  const _ = require('lodash');
  const moment = require('moment');
  require('moment-timezone');
  moment.tz.setDefault('Africa/Johannesburg');
  
  import Vue from 'vue'
  import utils from '@/utils/utils.js';
  import storeHelpers from '@/utils/storeHelpers.js';
  import pageVisibility from '@/utils/pageVisibility.js';

  const aesjs = require('aes-js');

  export default {
    name: 'AssessmentPlayer',
    components: {
    },
    props: {
      resource: {
        type: Object
      },
      attachment: {
        type: Object
      },
      wantToClose: {
        type: Boolean
      }
    },
    data: function () {
      var t = this;

      return {
        additionalData: [],
        data: [],
        inFocus: true
      }
    },
    mounted() {
      pageVisibility.addEventListener(this.handleVisibilityChange);
      storeHelpers.checkActive(this);
    },
    destroyed() {
      pageVisibility.removeEventListener(this.handleVisibilityChange);
    },
    watch:{
      wantToClose(val){
        if (val) {          
          this.postAssessmentAttempt();
        }
      }
    },
    methods: {
      handleVisibilityChange: function (inFocus) {
        if(this.inFocus !== inFocus) {
          this.inFocus = inFocus;
          if(this.inFocus) {
            this.focusGained();
          } else {
            this.focusLost();
          }
        }
      },
      postAssessmentAttempt: function() {
        var dataObj = JSON.parse(this.data)

        storeHelpers.addItemToSync(this, {
          url: this.$config.get('dns') + '/educator' + dataObj.url,
          method: "post",
          data: {
            assessment_data: JSON.stringify(dataObj),
            additional_data: JSON.stringify(this.additionalData)
          }
        })

        storeHelpers.markAsRead(this, this.resource, this.attachment);
      },
      focusGained: function() {
        this.pushState("focus-gained")
      },
      focusLost: function() {
        this.pushState("focus-lost")
      },
      pushState: function(name) {
        this.additionalData.push({name: name, time: moment().unix()})
      },
      loadAssessmentDetails: function() {
        var t = this;
        if (t.attachment && !t.attachment.locked && t.attachment.visible) {
          axios.get(this.resource.absoluteUrl)
          .then(response => {
            var encryptedBytes = utils.base64ToByteArray(response.data.questionData);
            var decodedIV = utils.base64ToByteArray(response.data.iv);
            var decodedKey = utils.base64ToByteArray('cXRadIeXLcd0LlOglZM8xA==');
            var aesCbc = new aesjs.ModeOfOperation.cbc(decodedKey, decodedIV);
            var decryptedBytes = aesjs.padding.pkcs7.strip(aesCbc.decrypt(encryptedBytes));
            var decryptedText = aesjs.utils.utf8.fromBytes(decryptedBytes);
            document.querySelectorAll("#assessmentIframe").forEach( item => {
              item.contentWindow.Sync = {
                assessmentTransition: function(json) {
                  t.$emit("canBeClosed", false);
                  t.data = json;
                  // todo markSeenAttachmentOnlyId(attachmentId)
                  // todo markLPItemProgress(attachmentId, 100)
                },
                assessmentComplete: function(json) {
                  t.$emit("canBeClosed", true);
                  t.data = json;
                  t.pushState("assessment-completed")
                  t.postAssessmentAttempt();
                }
              };
              item.contentWindow.iago.start(JSON.parse(decryptedText), this.attachment)
            })
          })
          .catch(function(error) {
            console.error(error);
            t.error = error;
          })
        }
      }
    }
  }
</script>

<style scoped lang="scss">
@import "src/css/vars.scss";

#assessmentIframe {
  width: 100%;
  height: calc(100vh - 130px);
}
</style>